// Route Pages
const VerificationCode = () => import('../../../components/common/pages/VerificationCode.vue')
const VerifyEmail = () => import('../../../components/common/pages/VerifyEmail.vue')
const VerificationMethod = () => import('../../../components/common/pages/VerificationMethod.vue')
const CheckYourText = () => import('../../../components/common/pages/ProvePhoneVerification/CheckYourText.vue')
const UpdatePhoneNumber = () => import('../../../components/common/pages/ProvePhoneVerification/UpdatePhoneNumber.vue')

export default () => {
  return [
    {
      path: 'Email',
      name: 'UpdateUserEmail',
      component: VerifyEmail,
      props: true
    },
    {
      path: 'Code',
      name: 'UpdateUserVerificationCode',
      component: VerificationCode,
      props: true
    },
    {
      path: 'VerificationMethod',
      name: 'UpdateUserVerificationMethod',
      component: VerificationMethod,
      props: true
    },
    {
      path: 'CheckYourText',
      name: 'CheckYourText',
      component: CheckYourText,
      props: true
    },
    {
      path: 'UpdatePhoneNumber',
      name: 'UpdatePhoneNumber',
      component: UpdatePhoneNumber,
      props: true
    }
  ]
}
